<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101.73 101.73">
    <g>
      <path
        d="m76.3,28.28c5.34,6.01,8.58,13.92,8.58,22.58s-3.24,16.58-8.58,22.58c3.77,4.25,8.59,7.54,14.05,9.48,7.11-8.75,11.38-19.91,11.38-32.06s-4.27-23.31-11.38-32.06c-5.46,1.94-10.28,5.23-14.05,9.48Zm-14.05,54.64c-3.56,1.26-7.39,1.95-11.38,1.95-18.79,0-34.01-15.23-34.01-34.01s15.23-34.01,34.01-34.01c3.99,0,7.82.69,11.38,1.95,3.9-4.8,8.67-8.88,14.05-12C68.82,2.48,60.13,0,50.87,0,22.77,0,0,22.77,0,50.87s22.77,50.87,50.87,50.87c9.27,0,17.95-2.48,25.43-6.81-5.39-3.12-10.15-7.19-14.05-12Zm-11.36-50.7c-10.29,0-18.64,8.34-18.64,18.64s8.34,18.64,18.64,18.64,18.64-8.34,18.64-18.64-8.34-18.64-18.64-18.64Zm0,28.74c-5.58,0-10.1-4.52-10.1-10.1s4.52-10.1,10.1-10.1,10.1,4.52,10.1,10.1-4.52,10.1-10.1,10.1Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>

<style scoped></style>
